"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _redux = require("redux");

var _UpdateSiteSettings = _interopRequireDefault(require("../stagedObjects/UpdateSiteSettings"));

var _default = (0, _redux.combineReducers)({
  updateSiteSettings: _UpdateSiteSettings.default.getReducer()
});

exports.default = _default;
module.exports = exports.default;